import type React from 'react';

/**
 * Shared visual identity for cheats.
 *
 * Every control that bypasses real gameplay — and the HUD toggle that reveals them —
 * uses this amber palette so a player can always tell at a glance which buttons are
 * cheats and which are the game proper. Cheats whose whole purpose is forcing a specific
 * outcome (win/lose, succeed/fail) keep a green/red accent for legibility, but they are
 * wrapped in a `CheatGroup` so the amber framing still marks them as cheats.
 */
export const CHEAT_BORDER = '#cc9933';
export const CHEAT_BORDER_ACTIVE = '#ffce63';
export const CHEAT_TEXT = '#ffcc66';
export const CHEAT_BG = 'rgba(255, 200, 100, 0.12)';
export const CHEAT_BG_ACTIVE = 'rgb(179 130 40 / 0.8)';
export const CHEAT_LABEL_TEXT = '#cc9933';

const CHEAT_SUCCESS_BG = '#0e2a14';
const CHEAT_SUCCESS_BORDER = '#44aa44';
const CHEAT_SUCCESS_TEXT = '#88ff88';

const CHEAT_FAILURE_BG = '#2a0e0e';
const CHEAT_FAILURE_BORDER = '#aa4444';
const CHEAT_FAILURE_TEXT = '#ff8888';

/** The default cheat button: amber on a translucent amber wash. */
export const cheatButtonStyle: React.CSSProperties = {
  background: CHEAT_BG,
  border: `1px solid ${CHEAT_BORDER}`,
  borderRadius: 4,
  color: CHEAT_TEXT,
  fontFamily: 'monospace',
  fontSize: 11,
  padding: '3px 10px',
  cursor: 'pointer',
  flexShrink: 0,
};

/** Cheat that forces a favourable outcome. */
export const cheatSuccessButtonStyle: React.CSSProperties = {
  background: CHEAT_SUCCESS_BG,
  border: `1px solid ${CHEAT_SUCCESS_BORDER}`,
  borderRadius: 6,
  color: CHEAT_SUCCESS_TEXT,
  fontFamily: 'monospace',
  fontSize: 12,
  padding: '4px 10px',
  cursor: 'pointer',
};

/** Cheat that forces an unfavourable outcome. */
export const cheatFailureButtonStyle: React.CSSProperties = {
  background: CHEAT_FAILURE_BG,
  border: `1px solid ${CHEAT_FAILURE_BORDER}`,
  borderRadius: 6,
  color: CHEAT_FAILURE_TEXT,
  fontFamily: 'monospace',
  fontSize: 12,
  padding: '4px 10px',
  cursor: 'pointer',
};
